export default "__VITE_ASSET__BoyViPfB__"